"use client";

import { Link } from "@/i18n/navigation";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";

export default function PopularListItemCard({ item, className = "" }) {
  if (!item) return null;

  const href = item.RedirectUrl || "/";

  return (
    <Link
      className={clsx(
        "cursor-pointer text-base font-medium text-gray-900",
        className,
      )}
      href={href}
    >
      <div className="flex flex-row items-center gap-2 py-1">
        <span>{item.Origin}</span>
        <FontAwesomeIcon
          className="text-border-strong"
          icon={byPrefixAndName.fak["half-right-arrow"]}
        />
        <span>{item.Destination}</span>
      </div>
      {item.StartingPriceText && (
        <span
          className="text-foreground-muted font-medium"
          dangerouslySetInnerHTML={{ __html: item.StartingPriceText }}
        />
      )}
    </Link>
  );
}
